<list-view *ngIf="listeUserContrat" [liste]="listeUserContrat"></list-view>